import { useEffect, useState } from 'react';
import { MarketingModal } from './MarketingModal/MarketingModal';
import { MarketingModalMini } from './MarketingModalMini/MarketingModalMini';
import s from './Modals.module.scss';
import { TextFields } from 'components/TextFileds/TextFileds';
import { StyledHTMLFieldsBlock } from 'components/StyledHTMLFiledsBlock/StyledHTMLFieldsBlock';
import { TextFieldsBlock } from 'components/TextFieldsBlock/TextFieldsBlock';
import { useSelector } from 'react-redux';
import { DropDown } from 'components/DropDown/DropDown';
import { InputImage } from 'components/InputImage/InputImage';
import { Checkbox, Input } from '@mui/material';
import { StyledNumberInput } from 'components/StyledNumberInput/StyledNumberInput';
import { PrimaryButton } from 'components/PrimaryButton/PrimaryButton';
import { useGetModalQuery, useUpdateModalMutation } from '../../redux/apis/modalApi';
import { ValidateTextFields } from 'utils/validation';
import { useStatusContext } from 'components/StatusProvider';
import { useGetLangsQuery } from '../../redux/apis/langApi';
import { Preloader } from 'components/Preloader/Preloader';

export const Modals = () => {

    // ### State
    const [form, setForm] = useState<any>({
        title: {},
        description: {},
        image: {},
        button: {},
        link: "",
        interval: 24,
        active: true
    })
    const { data: langs, isLoading: isLangsLoading } = useGetLangsQuery({});
    const [lang, setLang] = useState<any>()
    const { openStatus } = useStatusContext();

    const [updateModal, {isLoading: isUpdateLoading}] = useUpdateModalMutation()
    const {data: modal, isLoading} = useGetModalQuery({})
    

    // ### Effects
    useEffect(()=>{
        if(langs?.data) setLang(langs?.data?.[0]?.key)
    },[langs]);

    useEffect(()=>{
        if(modal){
            setForm(modal)
        }
    },[modal]);

    // ### Functions
    async function handleSaveModal(){
        let error: any = false
        if(!ValidateTextFields(form.title, langs?.data)) error= "Please enter title"
        if(!ValidateTextFields(form.description, langs?.data)) error= "Please enter description"
        if(!ValidateTextFields(form.button, langs?.data)) error= "Please enter button text"
        if(!form?.link?.length) error= "Please enter button link"
        if(!form?.interval) error= "Please enter display interval"

        if(error){
            openStatus('error', error);
            return
        }

        const response = await updateModal(form)
        if(response?.data?.message === "success")
            openStatus('success', "Modal updated");
        
    }

    // ### Views
    if(isLangsLoading || isLoading) return <Preloader />

    return(
        <div className={s.wrapper}>
            <div className={s.modals_row}>
                <div className={s.left_modal}>
                    <MarketingModal
                        title={form.title[lang]}
                        description={form.description[lang]}
                        image={form.image}
                        button={form.button[lang]}
                    />
                </div>
                <div className={s.right_modal}>
                    <MarketingModalMini
                        title={form.title[lang]}
                        description={form.description[lang]}
                        image={form.image}
                        button={form.button[lang]}
                    />
                </div>
            </div>
            
            <div className={s.row}>
                <div className={s.column}>
                    <StyledHTMLFieldsBlock 
                        values={form.title}
                        title={"Title"}
                        changeValue={(value)=> setForm((prev: any) => ({...prev, title: {...prev.title, ...value}}))}
                        activeLang={lang}
                        setActiveLang={setLang}
                        height={200}
                    />
                </div>
                <div className={s.column}>
                    <StyledHTMLFieldsBlock 
                        values={form.description}
                        title={"Description"}
                        changeValue={(value)=> setForm((prev: any) => ({...prev, description: {...prev.description, ...value}}))}
                        activeLang={lang}
                        setActiveLang={setLang}
                        height={200}
                    />
                </div>
            </div>

            <div className={s.row}>
                <div className={s.column}>
                    <InputImage 
                        title={'Image'}
                        setImage={(val: any) => setForm((prev: any) => ({...prev, image: val}))}
                        image={form.image}
                    />
                </div>
                <div className={s.column}>
                    <TextFields 
                        title="Button"
                        values={form.button}
                        changeValue={(value)=> setForm((prev: any) => ({...prev, button: {...prev.button, ...value}}))}
                    />
                    <div className={s.row}>
                        <div className={s.column}>
                            <div>
                                <span className={s.title}>Link</span>
                                <input 
                                    type="text" 
                                    value={form.link}
                                    onChange={(ev) => setForm((prev: any) => ({...prev, link: ev.target.value}))}
                                />
                            </div>
                        </div>
                        <div className={s.column}>
                            <div style={{transform: "translate(50px, 10px)"}}>
                                <span className={s.title}>Display interval (in hours)</span>
                                <StyledNumberInput 
                                    value={form.interval}
                                    onChange={(val: any) => setForm((prev: any) => ({...prev, interval: val}))}
                                />
                            </div>
                        </div>
                        <div className={s.column}>
                            <div style={{transform: "translateY(35px)", display: "flex", gap: 10}}>
                                <input 
                                    type="checkbox"
                                    checked={form.active}
                                    onChange={(ev) => setForm((prev: any) => ({...prev, active: ev.target.checked}))}
                                />
                                <span className={s.title}>Active modal</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className={s.buttons_wrapper}>
                <PrimaryButton 
                    text='Save'
                    onClick={handleSaveModal}
                    type={'button'}
                    style={{width: "fit-content"}}
                    disabled={isUpdateLoading}
                />
            </div>
        </div>
    )
}